var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E3E3E",
    d: "M44,50H6c-3.314,0-6-2.686-6-6V4h50v40C50,47.314,47.314,50,44,50z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 34,
    fill: "#804998",
    width: 23,
    height: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    fill: "#804998",
    width: 7,
    height: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    opacity: 0.2,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 7,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    fill: "#E5E5E5",
    width: 11,
    height: 12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    opacity: 0.2,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 11,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 4,
    fill: "#804998",
    width: 4,
    height: 12
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 4,
    opacity: 0.2,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 4,
    height: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 4,
    fill: "#59B4D9",
    width: 11,
    height: 12
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 4,
    opacity: 0.2,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 11,
    height: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 34,
    opacity: 0.2,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 23,
    height: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 34,
    fill: "#59B4D9",
    width: 16,
    height: 12
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 34,
    opacity: 0.2,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 16,
    height: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19,
    fill: "#E5E5E5",
    width: 23,
    height: 12
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19,
    transform: "matrix(-1 -4.484203e-11 4.484203e-11 -1 69 40)",
    opacity: 0.2,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 23,
    height: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 19,
    fill: "#59B4D9",
    width: 16,
    height: 12
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 19,
    transform: "matrix(-1 -4.502011e-11 4.502011e-11 -1 24 40)",
    opacity: 0.2,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 16,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M6,50h2.696L40.081,4H0v40C0,47.314,2.686,50,6,50z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureBlob);
export default __webpack_public_path__ + "static/media/azure_blob.9db817b496198d6dc2e00c675cd99c04.svg";
export { ForwardRef as ReactComponent };